import React from 'react';
import './TopNavBar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import { Nav, Button, NavDropdown } from 'react-bootstrap';

/* const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    setIsLogin(true);
    navigate("/");
}; */

const TopNavBar = ({ onLogout, userRole }) => {
  const currentPath = window.location.pathname;
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
      <div className="container-fluid">
        <a className="navbar-brand" href="#">Promosells</a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navmenus" aria-controls="navmenus" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navmenus">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a className={`nav-link ${currentPath === '/overview' || currentPath === '/' ? 'active' : ''}`} aria-current="page" href="/overview">Home</a>
            </li>
            <li className="nav-item">
              <Nav.Link href="/stocklist" className={`nav-item ${currentPath === '/stocklist' ? 'active' : ''}`}>Stocklist</Nav.Link>
            </li>
            <li className="nav-item">
              <Nav.Link href="/customers" className={`nav-item ${currentPath === '/customers' ? 'active' : ''}`}>Customers</Nav.Link>
            </li>
            <li className="nav-item">
              <Nav.Link href="/customer-map" className={`nav-item ${currentPath === '/customer-map' ? 'active' : ''}`}>Customer Map</Nav.Link>
            </li>
            <li className="nav-item">
              {/* Reports Dropdown */}
              <NavDropdown title="Reports" id="reports-nav-dropdown" className={`nav-item ${currentPath.startsWith('/report') ? 'active' : ''}`}>
                {userRole === 'Admin' && (
                  <NavDropdown.Item href="/report" className={currentPath === '/report' ? 'active' : ''}>Stock Reports</NavDropdown.Item>
                )}
                <NavDropdown.Item href="/incident-report-by-date" className={currentPath === '/incident-report-by-date' ? 'active' : ''}>Incident Report by Date</NavDropdown.Item>
                {/* Add more report types here as needed */}
              </NavDropdown>
            </li>
            {userRole === 'Admin' && (
              <li className="nav-item">
                <Nav.Link href="/users" className={`nav-item ${currentPath === '/users' ? 'active' : ''}`}>Users</Nav.Link>
              </li>
            )}
            <li className="nav-item">
              <Nav.Link href="/settings" className={`nav-item ${currentPath === '/settings' ? 'active' : ''}`}>Settings</Nav.Link>
            </li>
            <li className="nav-item">
              <Nav.Link href="/changepassword" className={`nav-item ${currentPath === '/changepassword' ? 'active' : ''}`}>Account</Nav.Link>
            </li>
          </ul>
          <div className="d-flex ms-auto">
            <Button variant="outline-light" onClick={onLogout} data-testid="logout-btn">
              Logout
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default TopNavBar;